<template>
  <!-- <Control class="cx_slideControl" :title="title" :isEdit="isEdit && enabled"  :height="36 + (isEdit&&enabled?rows - 1:0 ) * 25" :validator="validator" :provider="editor ? editor.owner:null"  :isDirectEditEnabled="isDirectEditEnabled"   :editor="editor"   :enabled="enabled"  :tooltip="tooltip"  :key="title"  :required="required"> -->
  <div class="cx_slideControl" >
    <div class="cx_page_count">
        <span>{{slideId + 1}} / {{itemCount}}</span>
    </div>
    <div class="cx_instruction">
        <div class="cx_button_left" v-if="slideItems" @click="moveBack" :class="{disabled : slideId <= 0, slideItems: false}"><i class="material-icons valign"  style="pointer-events:none;">arrow_left</i></div>
        <div class="cx_center_data"  >
            <slot :currentItem="currentItem"></slot>
        </div>
        <div class="cx_button_right" v-if="slideItems" @click="moveNext" :class="{disabled : !slideItems || slideId == slideItems.length -1, slideItems: false}"><i class="material-icons valign"  style="pointer-events:none;">arrow_right</i></div>              
    </div>     
  </div>
</template>


<script lang="ts">
import { Component, Prop, Vue, Emit,Watch } from 'vue-property-decorator';
import * as Components from '@/agiles/components';

@Component
export default class SlideControl extends Vue implements Components.IControl {
  @Prop({default:null}) public editor: Components.IEditor;
  @Prop({default:null}) public slideItems:any;
  @Prop({default:true}) public enabled: boolean;
  @Prop({default:true}) public isEdit: boolean;
  public currentItem:any = null;
  public slideId:number = -1;
  public itemCount:number = 0;
  public validator: Components.ControlValidator;

  public mounted() {
    if(this.slideItems)this.itemCount = this.slideItems.length;
    if (this.editor != null) this.editor.addControl(this);
    this.slideId=0;
  }

  @Watch('slideItems')
  public onSlideItemsUpdated(){
    //コレクションのリロード時に再バインドする
    this.onslideIdChanged();
  }

  @Watch('slideId')
  public onslideIdChanged(){
    if (this.slideId == -1 || this.slideItems == null) this.currentItem = null;
    else this.currentItem = this.slideItems[this.slideId];
  }
  public moveBack(){
    if (this.slideItems && this.slideItems.length > 0 && this.slideId > 0)this.slideId--;
  }
  public moveNext(){
    if (this.slideItems && this.slideItems.length > this.slideId +1)this.slideId++;
  }
  public get canMoveNext(){
    return this.slideItems && this.slideItems.length > this.slideId +1;
  }
  public get canMoveBack(){
    return this.slideItems && this.slideItems.length > 0 && this.slideId > 0;
  }

  public isTouchStarted: boolean  = false;
  public startPosition: number = 0;
  public offset: number = 0;
  public onTouchStart(e: any){
    if (this.isTouchStarted == false){
      this.isTouchStarted = true;
      this.startPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      console.log('touch started');
    }
  }
  public onTouchMove(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      this.offset = currentPosition - this.startPosition;
      if (this.offset > 0 && this.canMoveBack == false) this.offset = 0;
      else if (this.offset < 0 && this.canMoveNext == false) this.offset = 0;
      console.log('touch moved');
    }
  }  
  public onTouchEnd(e: any){
    if (this.isTouchStarted){
      var currentPosition = e.changedTouches ? e.changedTouches[0].screenX : e.screenX;
      if (currentPosition - this.startPosition > 80 && this.canMoveBack) this.slideId -=1;
      else if (currentPosition - this.startPosition < -80 && this.canMoveNext) this.slideId +=1;
      
      this.isTouchStarted = false;
      this.offset = 0;
      console.log('touch ended {0}->{1}', this.startPosition,currentPosition);      
    }
  }
}
</script>

<style lang="scss">
.cx_slideControl{
    min-width:unset;
    max-width:unset;
    margin-bottom:20px;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    .cx_page_count {
      width: 100%;
      margin-right:10px;
      display:flex;
      justify-content: flex-end;
    }
  .cx_instruction{
    flex:1;
    border: solid 1px #d3d3d3;    
    display:flex;
    height: 100%;
    width: 100%;
    overflow-y: hidden;
    .cx_button_left,
    .cx_button_right{
      width:20px;
      background-color:#b63a09;
      display:flex;
      align-items: center;
      color: white;
      &.items{
        background-color: #008b8b ;          
      }
      &.disabled{ 
        opacity: 0.2;
        pointer-events: none; 
      }
      &:hover:not(.disabled){
        opacity: 0.8;      
        cursor: pointer;
      }
      .material-icons{
        font-size:20px;
      }
    }

    .cx_center_data{
      flex-direction: column;
      flex:1;
      padding:10px 10px;      
      overflow-y:auto;
      display:flex;
      justify-content: center;
      position:relative;
      min-height: 200px;
        padding:10px;
      .cx_control {
        .cx_control_caption{
          width:115px;
        }
      }
    }
  }
}

</style>



